import axios from 'axios';
import i18n from '../i18n';
import { getApiBaseUrl } from '../apiBase';
import { parseCatalogResponse, parseListResponse } from './demoCatalog';

const api = axios.create({ baseURL: getApiBaseUrl() });

function authHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function apiErrorMessage(err, fallback) {
  const data = err?.response?.data;
  return data?.message || data?.detail || data?.title || fallback;
}

export async function fetchDemoSchools() {
  const res = await api.get('/demo/schools', { headers: authHeaders() });
  return parseListResponse(res.data);
}

export async function fetchDemoCatalog() {
  const res = await api.get('/demo/catalog', { headers: authHeaders() });
  return parseCatalogResponse(res.data);
}

export async function enableDemoSchool(sportTypeId) {
  try {
    const res = await api.post('/demo/enable', { sportTypeId }, { headers: authHeaders() });
    return res.data;
  } catch (err) {
    throw new Error(apiErrorMessage(err, i18n.t('demoTour:enableFailed')));
  }
}

export async function disableDemoSchool() {
  const res = await api.post('/demo/disable', {}, { headers: authHeaders() });
  return res.data;
}

export async function fetchDemoStats(demoSchoolId) {
  const res = await api.get(`/demo/schools/${demoSchoolId}/stats`, { headers: authHeaders() });
  return res.data;
}

export async function markDemoViewed() {
  const res = await api.post('/demo/viewed', {}, { headers: authHeaders() });
  return res.data;
}
